export default function getIssueLevel(issue) {
  return (issue.display_name ?? issue.name).split("/").length;
}
